import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import AreaExposicao from '../AreaExposicao';
import AreaInstitucional from '../AreaInstitucional';
import { ContactIcons, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo } from '../../config';
import {
  Container,
  SecondaryContainer,
  ContainerWhite,
  GreyContainer,
  Capa,
  ProgramContainer,
  Sponsors,
  Photo,
} from './styles';

import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useModal } from '../../hooks/Modal';


import Publicas from './modules/publicas';

import { usePages } from '../../hooks/Pages';

import SponsorsList from '../Sponsors';
import Program from '../../components/Program';
import Youtube from '../../components/Youtube';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Home: React.FC = () => {
const {addModal} = useModal();
  useEffect(() => {
    /*
    addModal({
        key: 'popup',
        title: '',
        content: (
          <>
            <a href="http://confies.org.br/institucional/premio-boas-praticas-de-gestao-das-fundacoes-de-apoio/" target="_BLANK"><img src="/apoio/popup.jpeg" style={{width: '100%', maxWidth: '500px', margin: '10px auto'}}/></a>
          </>
        ),
      }); */
    }, []);

  return (
    <>
      <Capa>
        <div className="p50" style={{marginTop: '30px'}}>

          <img src="/assets/logo.png" style={{width: '100%', maxWidth: '800px'}}/>
          <h2 style={{ margin: '20px auto', color: '#d1c2ff', fontSize: '32px'}}>29 de novembro a 01 de dezembro de 2021</h2>
          <div
            className=""
            style={{
              width: '100%',

              marginBottom: '20px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            {' '}
            <Link className="" to="/certificados">
              <Button type="button">Certificados</Button>
{' '}
            </Link>
            <Link className="" to="/inscricao">
              <Button type="button">Inscreva-se</Button>
{' '}
            </Link>

            <Link className="" to="/login">
              <Button type="button">Acesse</Button>
{' '}
            </Link>
         
         
          </div>
        
        
        </div>

     
      </Capa>
      <SponsorsList/>
    </>
  );
};
export default Home;
